import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MaintenanceDialogComponent } from '../parkifly-bookings/organizations/pages/home/home.component';

interface MaintenanceConfig {
  enabled: boolean;
  startTime: string;
  endTime: string;
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  private dialogRef: any;
  private config: MaintenanceConfig = {
    enabled: false,
    startTime: "19:45",
    endTime: "21:30"
  };

  constructor(private dialog: MatDialog) {
    this.startMonitoring();
  }

  private startMonitoring() {
    setInterval(() => {
      this.checkMaintenanceTime();
    }, 30000);
  }

  checkMaintenanceTime() {
    if (!this.config.enabled) {
      if (this.dialogRef) {
        this.dialogRef.close();
      }
      return;
    }

    const now = new Date();
    const swedishTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Stockholm" }));

    const [startHour, startMinute] = this.config.startTime.split(':').map(Number);
    const [endHour, endMinute] = this.config.endTime.split(':').map(Number);

    const currentTime = swedishTime.getHours() * 60 + swedishTime.getMinutes();
    const startTimeMinutes = startHour * 60 + startMinute;
    const endTimeMinutes = endHour * 60 + endMinute;

    const isInMaintenanceWindow = currentTime >= startTimeMinutes && currentTime < endTimeMinutes;

    if (isInMaintenanceWindow && !this.dialogRef) {
      this.dialogRef = this.dialog.open(MaintenanceDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        backdropClass: 'maintenance-backdrop',
        data: { endTime: this.config.endTime }
      });

      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    } else if (!isInMaintenanceWindow && this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
